import { useEffect, useState } from 'react';

import { SearchFieldProps } from './search-field.types';

/**
 * A custom hook to manage the state of a search field.
 * @returns An object containing the search value and handlers for input change and clear actions.
 */
export function useSearchFieldState(props?: Pick<SearchFieldProps, 'value'>) {
  const [searchValue, setSearchValue] = useState(props?.value || '');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const handleClear = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSearchValue('');
  };

  // Update internal state when controlled value prop changes
  useEffect(() => {
    if (props?.value !== undefined) {
      setSearchValue(props.value);
    }
  }, [props?.value]);

  return {
    searchValue,
    handleInputChange,
    handleClear,
  };
}
